import { render } from "./Gardens.vue?vue&type=template&id=1825ad33"
import script from "./Gardens.vue?vue&type=script&lang=js"
export * from "./Gardens.vue?vue&type=script&lang=js"

import "./Gardens.vue?vue&type=style&index=0&id=1825ad33&lang=scss"

import exportComponent from "/home/forge/app-ticket.grandigiardini.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__